let isDev = false;

try {
    isDev = process.env.NODE_ENV === 'development';
} catch (err) {
    console.log('检测环境错误', err);
}

const host = isDev ? 'http://localhost:8002' : 'https://api.****.xyz';

export default host;
